export const REQUEST_YOUTUBE_ID = 'content/REQUEST_YOUTUBE_ID';
export const RECEIVE_YOUTUBE_ID = 'content/RECEIVE_YOUTUBE_ID';
export const FAILURE_YOUTUBE_ID = 'content/FAILURE_YOUTUBE_ID';
export const REQUEST_FEATURE_SWITCHES = 'content/REQUEST_FEATURE_SWITCHES';
export const RECEIVE_FEATURE_SWITCHES = 'content/RECEIVE_FEATURE_SWITCHES';
export const UPDATE_BACK_BUTTON = 'content/UPDATE_BACK_BUTTON';
